import React, { memo } from "react";
import ImageComponent from "./ImageComponent.jsx";

const ImageWithAspectRatio = ({ height, src, alt = "Medical post media", onClick }) => {
  const formattedHeight =
    typeof height === "number"
      ? height > 630
        ? "630px"
        : `${Math.round(height)}px`
      : height > 630
      ? "630px"
      : height;

  const isContain =
    (typeof height === "number" && height > 630) ||
    (typeof height === "string" && parseInt(height, 10) > 630);

  return (
    <div
      style={{
        height: formattedHeight,
        width: "100%",
        backgroundColor: "#F8FAFC",
        position: "relative",
        overflow: "hidden",
      }}
      onClick={onClick}
    >
      <ImageComponent
        src={src}
        alt={alt}
        img_height={formattedHeight}
        img_width="100%"
        loader_height={formattedHeight}
        loader_width="100%"
        compClassName={isContain ? "object-contain w-100 h-100" : "object-cover w-100 h-100"}
        onClick={onClick}
      />
    </div>
  );
};

export default memo(ImageWithAspectRatio);
